import { render, staticRenderFns } from "./FormDataTable.vue?vue&type=template&id=35ed8eb8&scoped=true"
import script from "./FormDataTable.vue?vue&type=script&lang=js"
export * from "./FormDataTable.vue?vue&type=script&lang=js"
import style0 from "./FormDataTable.vue?vue&type=style&index=0&id=35ed8eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed8eb8",
  null
  
)

export default component.exports